import React from "react"

import RoleBasedBudgetSelector from "~/forms/ProjectBudgetForm/RoleBudget/RoleBasedBudgetSelector"
import { BudgetedRole } from "~/forms/ProjectBudgetForm/types"

import Column from "./TableColumn"
import Row from "./TableRow"

type Props = {
  roles: readonly BudgetedRole[]
  dataTestSuffix?: string
  onAddRole: (roleId: number) => void
  onShowAllRoles?: () => void
  placeholder: string
  addAllLabel?: string
  addAllDataTest?: string
  contextLabel?: string
  className?: string
}

const RoleAdder: React.FC<Props> = (props) => {
  const {
    roles,
    dataTestSuffix,
    onAddRole,
    onShowAllRoles,
    placeholder,
    addAllLabel = "Add All",
    contextLabel,
    className,
  } = props

  return (
    <Row flex className={className}>
      <Column flex height={50}>
        <div style={{ width: "215px" }}>
          <RoleBasedBudgetSelector
            placeholder={
              contextLabel ? `${placeholder} to ${contextLabel}` : placeholder
            }
            roles={roles as BudgetedRole[]}
            addRole={onAddRole}
          />
        </div>
        {onShowAllRoles && roles.length > 0 && (
          <div style={{ width: "100px" }}>
            <a
              data-test={`add-rates-roles${dataTestSuffix ? `-${dataTestSuffix}` : ""}`}
              href=""
              onClick={(e) => {
                e.preventDefault()
                onShowAllRoles()
              }}
            >
              {addAllLabel}
            </a>
          </div>
        )}
      </Column>
    </Row>
  )
}

export default RoleAdder
